import * as React from "react";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import Toast from "../../../helper/Toast";
import CreateJobStatusFormView from "./CreateJobStatusFormView";
import JobStatus from "../../../../model/job/JobStatus";
import {createJobStatus} from "../../../../store/action/jobStatus/jobStatus";

interface IComponentProps {
	/**
	 * On successful created job status callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
}

interface IDispatchProps {
	/**
	 * Crete job status.
	 */
	createJobStatus: (data: JobStatus, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & IDispatchProps;

class CreateJobStatusForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<CreateJobStatusFormView onSubmit={this.onSubmit}
									 onCancel={this.props.onCancel}
									 isSubmitting={this.state.isSubmitting}/>
		);
	}

	onSubmit(data: JobStatus) {
		this.setState({isSubmitting: true}, () => {
			this.props.createJobStatus(
				data,
				() => {
					Toast.success("Job status created", "Job status creation");
					this.setState({isSubmitting: false});
					this.props.onSuccess();
				},
				(error) => {
					let err = "Sorry, something went wrong. Try again later.";
					if (error && error.response && error.response.status === 409
						&& error.response.data.exception == "DuplicateJobStatusLabelException") {
						err = "Job status with given name already exists";
					}

					Toast.error(err, "Job status creation");
					this.setState({isSubmitting: false});
				}
			);
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		createJobStatus: (data: JobStatus, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(createJobStatus(data, onSuccess, onFailure))
	};
}

export default connect(null, mapDispatchToProps)(CreateJobStatusForm);
